import * as React from 'react';
import Typography from '@mui/material/Typography';

const SecondaryHeaderText = ({ children }) => (
  <Typography component="h3" variant="h3">
    { children }
  </Typography>
);

export default SecondaryHeaderText;